import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as EmailAdminActions from './email-admin.actions';

export const emailAdminFeatureKey = 'emailAdmin';

export interface State {
  isSending: boolean;
  isSuccess: boolean;
  error: Error | null;
}

export const initialState: State = {
  isSending: true,
  isSuccess: false,
  error: null,
};

const sendingReducer = createReducer(
  initialState.isSending,
  on(EmailAdminActions.emailAdmin, () => true),
  on(EmailAdminActions.emailAdminSuccess, () => false),
  on(EmailAdminActions.emailAdminFailure, () => false)
);

const successReducer = createReducer(
  initialState.isSuccess,
  on(EmailAdminActions.emailAdmin, () => false),
  on(EmailAdminActions.emailAdminSuccess, () => true),
  on(EmailAdminActions.emailAdminFailure, () => false)
);

const errorReducer = createReducer(
  initialState.error,
  on(EmailAdminActions.emailAdmin, () => null),
  on(EmailAdminActions.emailAdminFailure, (state, action) => action.error)
);

export const reducer: ActionReducerMap<State> = {
  isSending: sendingReducer,
  isSuccess: successReducer,
  error: errorReducer,
};
